import { isDefined, isNotDefined } from '@sgme/fp';
import deepEqual from 'fast-deep-equal';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { selectCurrencyPairPrecision } from '@/api/config/selectors.ts';
import { selectCashTile } from '@/store/cash/selectors/tile.ts';
import { useAppSelector } from '@/store/hooks.ts';

export type ForwardDoddFranckMidPriceProps = {
  tileId: string;
};

export const ForwardDoddFranckMidPrice = (props: ForwardDoddFranckMidPriceProps) => {
  const { tileId } = props;

  const { midPrice, currencyPairPrecision } = useAppSelector((state) => {
    const tile = selectCashTile(state, tileId);

    if (
      isNotDefined(tile) ||
      (tile.type !== 'FxFwd' && tile.type !== 'FxNdf') ||
      isNotDefined(tile.properties.currencyPair) ||
      isNotDefined(tile.properties.rfs) ||
      tile.properties.rfs.status !== 'STREAMED'
    ) {
      return {};
    }

    return {
      midPrice: tile.properties.rfs.quote.midAllInRate,
      currencyPairPrecision: selectCurrencyPairPrecision(state, tile.properties.currencyPair),
    };
  }, deepEqual);

  return (
    <div className="text-center fs-12 text-secondary">
      {isDefined(midPrice) ? (
        <>
          <FormattedMessage id="CashTile.doddFranckMidPrice.midPrice" />{' '}
          <span data-e2e="dodd-franck-mid-price">
            <FormattedNumber
              value={midPrice}
              minimumFractionDigits={(currencyPairPrecision ?? 1) + 1}
              maximumFractionDigits={(currencyPairPrecision ?? 1) + 1}
            />
          </span>
        </>
      ) : (
        <FormattedMessage id="CashTile.doddFranckMidPrice.reprice" />
      )}
    </div>
  );
};
